import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class Course1Service {
	constructor(private httpclientService: HttpclientService) {}
	loadCourse1List(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/Course1GetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
